module.exports = __webpack_public_path__ + "static/img/intersnine.a9eab12.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/intersnine.png
// module id = 81F/
// module chunks = 45